export const DEFAULT_BENEFIT = {
  admin_copay: "$",
  admin_coverage: "%",
  deductible: "$",
  deductible_met: "$",
  med_ben_notes: "",
  office_copay: "$",
  office_coverage: "%",
  out_of_pocket_max: "$",
  out_of_pocket_met: "$",
  product_copay: "$",
  product_coverage: "%",
}

export const TABLE_DATE_BASED_COLUMNS = [
  "bi_submitted",
  "bi_completed",
  "date_of_treatment",
  "date_of_next_treatment",
  "date_transferred",
  "date_shipped",
  "created_at",
  "created",
  "treated",
  "date_of_next_treatment",
  "received"
]

export const PRACTICE_TABLE_COLUMNS = [
  { label: "Name", value: "name", width: "150" },
  { label: "State", value: "state", width: "" },
  { label: "Phone", value: "phone", width: "" },
]

export const DOCTOR_TABLE_COLUMNS = [
  { label: "Name", value: "name", width: "150" },
  { label: "Practice", value: "practice", width: "" },
  { label: "State", value: "state", width: "" },
  { label: "Phone", value: "phone", width: "" },
]
